import { produce } from 'immer'
import merge from 'lodash.merge'
// @ts-ignore
import { str } from './utils'
import accountActions, {
  SET_CONNECTED_ACCOUNT,
  SET_ME_LOADING,
  CLEAR_ME,
  SET_ME_INTEGRATION_ENABLED,
  SET_ME_INTEGRATION_SETTINGS,
} from '../actions/account'
import authActions from '../actions/auth'

export interface AccountState {
  [id: string]: any
  _meAccount: any | null
  _meLoading: boolean
  _meError: any | null
  _connectedAccount: boolean
  _invoices: any[]
}

const initialState: AccountState = {
  _meAccount: null,
  _meLoading: false,
  _meError: null,
  _connectedAccount: false,
  _invoices: [],
}

const reducer = (draft: AccountState, { type, payload }: any) => {
  switch (type) {
    case str(accountActions.read.success): {
      const data = payload.data
      if (data && data.uid) {
        draft[data.uid] = merge(draft[data.uid] || {}, data)
      }
      return
    }
    case str(accountActions.fetchAccount.success): {
      const data = payload.data
      draft._meAccount = data
      draft._meLoading = false
      draft._meError = null
      return
    }
    case str(accountActions.fetchAccount.failure): {
      draft._meLoading = false
      draft._meError = payload
      return
    }
    case str(accountActions.updateAccount.success):
    case str(accountActions.updateAccountContact.success):
    case str(accountActions.updateAccountAddress.success): {
      const data = payload.data
      draft._meAccount = data
      draft._meLoading = false
      return
    }
    case str(accountActions.updateAccount.failure):
    case str(accountActions.updateAccountContact.failure):
    case str(accountActions.updateAccountAddress.failure): {
      draft._meLoading = false
      return
    }
    case str(accountActions.loadInvoices.success): {
      draft._invoices = payload.data || []
      return
    }
    case SET_CONNECTED_ACCOUNT:
      draft._connectedAccount = payload
      return
    case SET_ME_LOADING:
      draft._meLoading = payload
      return
    case SET_ME_INTEGRATION_ENABLED: {
      // Patch just the one integration flag so a toggle survives unmount
      // without refetching the whole account.
      if (!draft._meAccount) {
        return
      }
      const { key, enabled } = payload
      draft._meAccount.integrations = {
        ...(draft._meAccount.integrations || {}),
        [key]: {
          ...(draft._meAccount.integrations?.[key] || {}),
          is_enabled: enabled,
        },
      }
      return
    }
    case SET_ME_INTEGRATION_SETTINGS: {
      // As above, for everything on an integration that is not the on/off switch.
      if (!draft._meAccount) {
        return
      }
      const { key, settings } = payload
      draft._meAccount.integrations = {
        ...(draft._meAccount.integrations || {}),
        [key]: {
          ...(draft._meAccount.integrations?.[key] || {}),
          ...settings,
        },
      }
      return
    }
    case CLEAR_ME:
      draft._meAccount = null
      draft._meLoading = false
      draft._meError = null
      draft._connectedAccount = false
      draft._invoices = []
      return
    case str(authActions.logout.success):
      return initialState
  }
}

export default (state = initialState, action: any) =>
  produce(state, (draft: AccountState) => reducer(draft, action))
